module.exports = __webpack_public_path__ + "static/media/fuel.ac788a24.jpeg";